import React from 'react'

export default ({ title, onClick, marginTop, marginLeft, loading }) =>
    <button
        className={'add-title-btn' + (loading ? ' button is-loading' : '')}
        disabled={loading}
        style={{ marginTop, marginLeft, width: 100, fontSize: 17 }}
        onClick={onClick} >{title}</button>


// WEBPACK FOOTER //
// ./src/components/Regular/SmallBtn.js